module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg7-e27fcb7743a80a9cac831b9bd38e2b18.jpg";